<template>
  <div>

    <!-- Check if Node is Empty -->
    <div v-if="node._id">

        <div
          :style="{'margin-left': `${depth * 30}px`}"
          class="node"
        >

          <!-- &#9660 Down Pointing Arrow Icon -->
          <!-- &#9658 Right Pointing Arrow Icon -->
          <span
            style="position: absolute; z-index: 1;"
            @click="nodeClicked"
            v-if="haveChildren || hasID"
          >{{expanded ? '&#9660;' : '&#9658;'}}</span>

          <span v-else>&#9671;</span>

          <!-- ********************** -->
          <!-- **** Display Name **** -->
          <!-- ********************** -->
          <div class="dropdown pl-4">

            <div class="fieldName pl-2" v-if="!editNameSwitch">
              {{node.name}}
            </div>
            <!-- Edit Name Option -->
            <div @keyup.enter="editNameField" v-if="editNameSwitch">
              <v-card flat class="pl-2">
                <input type="text" style="border: 1px solid black; padding-left: 5px;" :value="node.name" @input="updateData($event, node, 'name')">
                <v-btn text small dark style="background-color: #ef5350; margin-bottom: 3px;" class="button ml-2" @click="editNameField">Done</v-btn>
              </v-card>
            </div>

            <!-- Add Field Option  -->
            <div v-if="addFieldSwitch" class="addField-content input-group">
              <v-card flat>
                <div style="width: 100%; ">
                  <div style="width: 200px; float: left;">
                    <div style="width: 100%; ">
                      <div style="width: 185px; float: left;">
                        <input type="text" placeholder="Field Name" style="border: 1px solid black; padding-left: 5px;">
                      </div>
                      <div style="margin-left: 185px;">
                        <input type="text" placeholder="Field Value" style="border: 1px solid black; padding-left: 5px;">
                      </div>
                    </div>
                  </div>
                  <div style="margin-left: 370px;" >
                    <v-btn text small dark style="background-color: #ef5350;" @click="addField">Done</v-btn>
                  </div>
                </div>
              </v-card>
            </div>
            <!-- Add Child Option -->
            <div v-if="addChildSwitch" class="addField-content input-group">
              <v-card flat>
                <div style="width: 100%;">
                  <div style="width: 185px; float: left;">
                    <input type="text" placeholder="Child Name" style="border: 1px solid black; padding-left: 5px;">
                  </div>
                <div style="margin-left: 140px;">
                  <v-btn text small dark style="background-color: #ef5350;" @click="addChild">Done</v-btn>
                </div>
              </div>
              </v-card>
            </div>
            <!-- Remove Child Option -->
            <div v-if="removeChildSwitch" class="addField-content input-group">
              <v-card flat>
                <div style="width: 100%;">
                  <div style="width: 185px; float: left;">
                    <input type="text" placeholder="Enter Child Name" style="border: 1px solid black; padding-left: 5px;">
                  </div>
                  <div style="margin-left: 140px;">
                    <v-btn text small dark style="background-color: #ef5350;" @click="removeChild">Done</v-btn>
                  </div>
              </div>
              </v-card>
            </div>

            <!-- **** Menu DropDown for Name Display **** -->
            <div v-if="menuExpandSwitch" class="dropdown-content">
              <v-btn-toggle>
                <v-btn text small class="button" @click="editNameField">Edit Name</v-btn>
              </v-btn-toggle>
            </div>
          </div>

          <!-- ****************************************************** -->
          <!-- **** Display Everything else that's not Root Data **** -->
          <!-- ****************************************************** -->
          <div v-if="root_id != node._id" style="margin-left: 30px;">

            <div v-if="expanded">



              <!-- *********************** -->
              <!-- **** Display Value **** -->
              <!-- *********************** -->
              <div v-if="node.value" class="dropdown pt-1">
                <div class="fieldName">
                  <span class="valueStyle">{{node.value}}</span>
                </div>
                <!-- Edit Value Option -->
                <div @keyup.enter="editValue" v-if="editValueSwitch" class="addField-content input-group">
                  <v-card flat>
                    <div style="width: 100%;">
                      <div style="width: 185px; float: left;">
                        <!-- :value="node.value" @input="updateData($event, node, 'value')" -->
                        <input placeholder="Enter Value" style="border: 1px solid black; padding-left: 5px;" >
                      </div>
                      <div style="margin-left: 140px;">
                        <v-btn text small dark style="background-color: #ef5350;" class="button" @click="editValue">
                          Done
                        </v-btn>
                      </div>
                    </div>
                  </v-card>
                </div>
                <!-- Remove Value Option -->
                <div v-if="deleteCheckSwitch" class="addField-content input-group">
                  <v-card flat>
                    <div style="width: 100%; ">
                      <div style="width: 90px; float: left;">
                        <v-btn text small dark style="background-color: #ef5350;" class="button" @click="deleteCheck">
                            Remove
                        </v-btn>
                      </div>
                      <div style="margin-left: 90px;">
                        <v-btn text small dark style="background-color: grey;" class="button" @click="deleteCheck">Cancel</v-btn>
                      </div>
                    </div>
                  </v-card>
                </div>
                <!-- **** Menu DropDown **** -->
                <div v-if="menuExpandSwitch" class="dropdown-content">
                  <v-btn-toggle>
                    <v-btn text small class="button" @click="editValue">Edit Value</v-btn>
                  </v-btn-toggle>
                </div>
              </div>

          </div>
        </div>
      </div>

      <!-- ******************************* -->
      <!-- **** Recursive Call        **** -->
      <!-- **** Loop through Children **** -->
      <!-- ******************************* -->
      <div v-if="expanded">
        <EditAttributes
          v-for="child in node.children"
          :key="child._id"
          :node="child"
          :depth="depth + 1"
        />
      </div>
    </div>

    <!-- ******************************************************* -->
    <!-- **** If Node is Please Wait if Display Unavailable **** -->
    <!-- ******************************************************* -->
    <div v-else>
      Please Wait...
    </div>

  </div>
</template>

<script>

export default {
  name: 'EditAttributes',
  props: {
    node: Object,
    root_id: String,
    depth: {
      type: Number,
      default: 0,
    }
  },
  data: function () {
    return {
      offset: true,
      root: '',
      expanded: false,
      menuExpandSwitch: true,
      editNameSwitch: false,
      addFieldSwitch: false,
      addChildSwitch: false,
      removeChildSwitch: false,
      editValueSwitch: false,
      deleteCheckSwitch: false,
      editAbbreviationSwitch: false,
      deleteAbbreviationSwitch: false,
      editPrecisionSwitch: false,
      deletePrecisionSwitch: false,
      editValueNameSwitch: false,
      deleteValueNameSwitch: false,
      editUomSwitch: false,
      deleteUomSwitch: false,
      editDisplayHintSwitch: false,
      deleteDisplayHintSwitch: false,
      editUomLongSwitch: false,
      deleteUomLongSwitch: false,
      editTypeSwitch: false,
      deleteTypeSwitch: false,
      addMetaSwitch: false,
    }
  },
  methods: {
    updateData(e, node, field) {
      if(!node || !e.currentTarget || !e.currentTarget.value){
        return
      }
      this.$store.dispatch('updatePatientData', {node: node, field: field, value: e.currentTarget.value, oldValue: e.currentTarget._value});
    },
    getRootId() {
      return this.root_id
    },
    menuExpand() {
      this.menuExpandSwitch = !this.menuExpandSwitch
    },
    // Switch for this.expanded
    nodeClicked() {
      this.expanded = !this.expanded
    },
    // Switch for this.editNameSwitch
    editNameField() {
      this.editNameSwitch = !this.editNameSwitch
      this.menuExpand()
    },
    // Switch for this.addFieldSwitch
    addField() {
      this.addFieldSwitch = !this.addFieldSwitch
      this.menuExpand()
    },
    // Switch for this.addChildSwitch
    addChild() {
      this.addChildSwitch = !this.addChildSwitch
      this.menuExpand()
    },
    // Switch for this.addChildSwitch
    removeChild() {
      this.removeChildSwitch = !this.removeChildSwitch
      this.menuExpand()
    },
    // Switch for this.editValueSwitch
    editValue() {
      this.editValueSwitch = !this.editValueSwitch
      this.menuExpand()
    },
    // Switch for this.deleteCheckSwitch
    deleteCheck() {
      this.deleteCheckSwitch = !this.deleteCheckSwitch
      this.menuExpand()
    },
    // Switch for editAbbreviationSwitch
    editAbbreviation() {
      this.editAbbreviationSwitch = !this.editAbbreviationSwitch
      this.menuExpand()
    },
    // Switch for this.deleteAbbreviationSwitch
    deleteAbbreviationCheck() {
      this.deleteAbbreviationSwitch = !this.deleteAbbreviationSwitch
      this.menuExpand()
    },
    // Switch for this.editPrecisionSwitch
    editPrecision() {
      this.editPrecisionSwitch = !this.editPrecisionSwitch
      this.menuExpand()
    },
    // Switch for this.deleteAbbreviationSwitch
    deletePrecisionSwitchCheck() {
      this.deletePrecisionSwitch = !this.deletePrecisionSwitch
      this.menuExpand()
    },
    // Switch for this.editValueNameSwitch *
    editValueName() {
      this.editValueNameSwitch = !this.editValueNameSwitch
      this.menuExpand()
    },
    // Switch for this.deleteValueNameSwitch
    deleteValueNameSwitchCheck() {
      this.deleteValueNameSwitch = !this.deleteValueNameSwitch
      this.menuExpand()
    },
    // Switch for this.editUomSwitch
    editUom() {
      this.editUomSwitch = !this.editUomSwitch
      this.menuExpand()
    },
    // Switch for this.deleteUomSwitch
    deleteUomSwitchCheck() {
      this.deleteUomSwitch = !this.deleteUomSwitch
      this.menuExpand()
    },
    // Switch for this.editDisplayHintSwitch
    editDisplayHint() {
      this.editDisplayHintSwitch = !this.editDisplayHintSwitch
      this.menuExpand()
    },
    // Switch for this.deleteDisplayHintSwitch
    deleteDisplayHintCheck() {
      this.deleteDisplayHintSwitch = !this.deleteDisplayHintSwitch
      this.menuExpand()
    },
    // Switch for this.editUomLongSwitch
    editUomLong() {
      this.editUomLongSwitch = !this.editUomLongSwitch
      this.menuExpand()
    },
    // Switch for this.deleteUomLongSwitch
    deleteUomSwitchLongCheck() {
      this.deleteUomLongSwitch = !this.deleteUomLongSwitch
      this.menuExpand()
    },
    // Switch for this.editTypeSwitch
    editType() {
      this.editTypeSwitch = !this.editTypeSwitch
      this.menuExpand()
    },
    // Switch for this.deleteTypeSwitch
    deleteTypeSwitchCheck() {
      this.deleteTypeSwitch = !this.deleteTypeSwitch
      this.menuExpand()
    },
    addMeta() {
      this.addMetaSwitch = !this.addMetaSwitch
      this.menuExpand()
    },
  },
  computed: {
    // Check for Children
    haveChildren() {
      return this.node.children
    },
    // Checks for ID to create drop down
    hasID() {
      return this.node._id
    }
  },
}

</script>

<style scoped>

  /* Buttons for Drop Menus */
  .fieldName {
    float: left;
    padding-right: 150px;
  }

  /* Wrap around where you what hover effects */
  .dropdown {
    display: inline-block;
  }

  /* Wrap around menu items */
  .dropdown-content {
    margin-bottom: 10px;
    display: none;
    z-index: 1;
  }

  /* Drop menu on hover */
  .dropdown:hover .dropdown-content {
    position: absolute;
    right: 0;
    width: 35%;
    display: block;

  }

  .addField-content {
    position: absolute;
    right: 0;
    width: 35%;
    display: inline-block;
  }

  /* Basic Styling for everything */
  .node {
    text-align: left;
    font-size: 17px;
  }

  /* Styling for field names */
  .nameStyle {
    color: #0066ff;
  }

  /* Styling for field values */
  .valueStyle {
    color: #505050;
  }

</style>
